import styled from "styled-components";

import uniFailCharactor from 'images/character/uni_fail.png'

export default function DenyOrderContent() {
  return (
    <Block>
      <ImageBlock>
        <Image src={uniFailCharactor}/>
      </ImageBlock>
      <CommentBlock>
        <Title>{`결제 실패`}</Title>
        <Description>{`죄송합니다.\n주문 결제가 정상처리 되지 않았습니다.`}</Description>
      </CommentBlock>
    </Block>
  )
}

const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: calc(100vw * (28 / 375));
`; 

const ImageBlock = styled.div`
  background-color: #FFFBF0;
  border-radius: 100%;
  width: calc(100vw * (140 / 375));
  height: calc(100vw * (140 / 375));
  padding-top: calc(100vw * (28 / 375));
  padding-bottom: calc(100vw * (21.85 / 375));
  padding-right: calc(100vw * (39.49 / 375));
  padding-left: calc(100vw * (22.54 / 375));
  margin-bottom: calc(100vw * (18 / 375));
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CommentBlock = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const Title = styled.h1`
  font-size: calc(100vw * (24 / 375));
  font-weight: 700;
  line-height: calc(100vw * (16 / 375));
  margin-bottom: calc(100vw * (17 / 375));
  color: #121212;
`;

const Description = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (16.8 / 375));
  white-space: pre-wrap;
  color: #121212;
`;

